/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { OwnerCellData } from '../OwnerCell';
import { Typography } from '@mui/material';
import PolicyClientCell from '@/components/table/DataGridComponents/PolicyClientCell';

export const CLIENT_PAGE_SIZE = 100;

/**
 * Columns aligned to Insight Contact/Search payload and firebase client payload.
 */
export const columns = [
	{
		field: 'Addressee',
		headerName: 'Contact name',
		editable: false,
		hideable: false,
		sortable: true,
		align: 'left',
		flex: 1.2,
		minWidth: 160,
		display: 'flex',
		renderCell: ({ row }) => (
			<Typography
				sx={(theme) => ({
					color: theme.palette.primary.main,
					fontWeight: 600,
				})}
			>
				{row.Addressee || '-'}
			</Typography>
		),
	},
	{
		field: 'EntityName',
		headerName: 'Client name',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 1,
		minWidth: 140,
		display: 'flex',
		renderCell: ({ row, colDef }) => (
			<PolicyClientCell
				ClientDocId={row.ClientDocId}
				ClientName={row.EntityName}
				width={colDef.minWidth}
				showContact={false}
			/>
		),
	},
	{
		field: 'IsPrimary',
		headerName: 'Main contact',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 0.8,
		minWidth: 120,
		display: 'flex',
		renderCell: ({ row }) => (row.IsPrimary ? 'Yes' : 'No'),
	},
	{
		field: 'Email',
		headerName: 'Email',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 1.5,
		minWidth: 200,
		display: 'flex',
	},
	{
		field: 'createdBy',
		headerName: 'Client owner',
		editable: false,
		hideable: true,
		sortable: false,
		align: 'left',
		flex: 1,
		minWidth: 160,
		display: 'flex',
		renderCell: ({ row }) =>
			row.createdBy ? (
				<OwnerCellData userId={row.createdBy} color='text.primary' />
			) : (
				<Typography>-</Typography>
			),
	},
	{
		field: 'Telephone',
		headerName: 'Telephone',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 1,
		minWidth: 140,
		display: 'flex',
	},
	{
		field: 'Telephone2',
		headerName: 'Telephone 2',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 1,
		minWidth: 140,
		display: 'flex',
	},
	{
		field: 'Mobile',
		headerName: 'Mobile',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 1,
		minWidth: 140,
		display: 'flex',
	},
	{
		field: 'JobTitle',
		headerName: 'Job title',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 1.2,
		minWidth: 160,
		display: 'flex',
	},
	{
		field: 'ContactTypeName',
		headerName: 'Contact type',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 1.2,
		minWidth: 160,
		display: 'flex',
	},
	{
		field: 'Salutation',
		headerName: 'Salutation',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 0.8,
		minWidth: 120,
		display: 'flex',
	},
	{
		field: 'EntityRef',
		headerName: 'Entity ref',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 1,
		minWidth: 120,
		display: 'flex',
	},
	{
		field: 'Id',
		headerName: 'Contact ID',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 0.7,
		minWidth: 100,
		display: 'flex',
	},
	{
		field: 'ContactTypeId',
		headerName: 'Contact type ID',
		editable: false,
		hideable: true,
		sortable: true,
		align: 'left',
		flex: 0.8,
		minWidth: 120,
		display: 'flex',
	},
];

/** Extra / secondary Insight fields — toggle via Columns toolbar. */
export const DEFAULT_HIDDEN_COLUMNS = [
	'Telephone',
	'Telephone2',
	'Mobile',
	'JobTitle',
	'ContactTypeName',
	'Salutation',
	'EntityRef',
	'Id',
	'ContactTypeId',
];
